import { useMemo } from 'react';

import { config } from '../../../config/config';

export function usePasswordReset() {
    const resetUrl = useMemo(() => {
        const url = new URL(config.AUTH_ENDPOINT);
        url.pathname = `/auth/realms/${config.KEYCLOAK_REALM}/protocol/openid-connect/auth`;
        url.searchParams.set('client_id', config.KEYCLOAK_CLIENT_ID);
        url.searchParams.set('redirect_uri', window.location.href);
        url.searchParams.set('kc_action', 'UPDATE_PASSWORD');
        url.searchParams.set('response_type', 'code');
        return url.href;
    }, []);

    return resetUrl;
}
